export const Functions = {
  create: false,
  delete: false,
  detail: false,
  search: true,
};

export const PageName = '帮助与反馈';
